import { AgentService } from '@/services/agent.service'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'

export const listAgentsQuery = queryOptions({
  queryKey: ['list-agents'],
  queryFn: () => AgentService.list(),
  placeholderData: keepPreviousData,
})
